import React from 'react';
import { Helmet } from 'react-helmet-async';
import './ConsultationPage.scss';
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const ConsultationPage = () => {
    return (
        <div className="solution-page">
            <Helmet>
                <title>AI Consultation Services - Majority AI | AI Strategy & Cost Optimization</title>
                <meta name="description" content="Expert AI consultation by Majority AI. Cost-effective AI strategy, model selection, and implementation guidance for businesses of all sizes." />
                <meta name="keywords" content="AI consulting, AI strategy, cost optimization, AI implementation, machine learning consulting, MajorityAI consultation" />
                <link rel="canonical" href="https://www.majorityai.com/consultation" />
            </Helmet>
            <Navbar/>
            <section className="slide-card-header" >
                <div className='wrapper'>
                    <div className="outer-frame"></div>
                    <div className="inner-container">
                        <h1>AI Strategy & Cost Optimization</h1>
                    </div>
                </div>
            </section>

            <section className="slide-card-content">
                <div className="wrapper2">
                    <p>
                    We help businesses make informed, cost-effective decisions about AI adoption. Not every problem requires a large language model—sometimes, we recommend a simpler, faster solution that the client can implement themselves.
                    </p>
                    <p>
                    When AI is the right fit, we design practical, high-impact systems by combining small and large LLMs with RAG and smart engineering. From model selection to deployment, we focus on balancing performance with operational cost.
                    </p>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default ConsultationPage;

